export default {
  padded: {
    paddingTop: '0'
  },
  tipeRoom: {
    '@media (min-width:801px)': {
      '& > span': {
        fontSize: '16px',
        lineHeight: 'normal'
      }
    }
  },
  nameType: {
    '@media (min-width:801px)': {
      '& > span': {
        fontSize: '13px',
        fontWeight: '500'
      }
    }
  }
};
